import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Col, Form, Input, Row, Space } from 'antd'
import { useEffect } from 'react'
import SBPhoneInput from '../../../../modules/sb-antd-phone-input/SBPhoneInput'
import { selectSelectedCompanyContact } from '../../../../store/business/CompanyContactReducer'
import { useAppSelector } from '../../../../store/hooks'
import { emailRule, isE164Phone, requiredRule } from '../../../../utils/rules'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedCompanyContact())
  useEffect(() => {
    form.setFieldsValue(item)
    form.setFieldValue('phone', {
      typed: item?.phone,
      raw: item?.phone,
    })
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Space
        style={{ display: 'flex', marginBottom: 8 }}
        orientation="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              name={'firstName'}
              rules={[requiredRule()]}
              label="First Name"
            >
              <Input placeholder="Contact First Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={'lastName'}
              rules={[requiredRule()]}
              label="Last Name"
            >
              <Input placeholder="Contact Last Name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              name={'email'}
              rules={[requiredRule(), emailRule()]}
              label="Email"
            >
              <Input
                className="authField"
                placeholder={'Contact Email'}
                autoComplete="email"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={'phone'}
              rules={[requiredRule(), isE164Phone()]}
              label="Phone"
            >
              <SBPhoneInput
                enableSearch
                disableParentheses
                sbInitialValue={item.phone}
                placeholder="Contact Phone"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              name={'position'}
              rules={[requiredRule()]}
              label="Position"
            >
              <Input placeholder="Contact Position" />
            </Form.Item>
          </Col>
        </Row>
      </Space>
    </Form>
  )
}

export default Update
